import {Injectable, inject} from '@angular/core';
import {Action, State, StateContext} from '@ngxs/store';
import {tap} from 'rxjs';
import {DashboardService} from '../../services';
import * as actions from './dashboard.actions';

@State<void>({name: 'dashboard'})
@Injectable({providedIn: 'root'})
export class DashboardState {
    dashboardService = inject(DashboardService);

    @Action(actions.GetDashboardActivityTypeStatus)
    activityTypeStatus(
        {dispatch}: StateContext<void>,
        {center, startDate, endDate}: actions.GetDashboardActivityTypeStatus
    ) {
        return this.dashboardService.activityTypeStatus(center, startDate, endDate).pipe(
            tap(data =>
                dispatch(
                    new actions.GetDashboardActivityTypeStatusResponse(data, {
                        state: 'success',
                    })
                )
            )
        );
    }
}
